<template>
  <div
    :style="{color: color}"
    class="v-loader">
    <div class="box">
      <v-svg class="fox">fox</v-svg>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',
    props: {
      icon: {
        type: String,
        default: ''
      },

      color: {
        type: String,
        default: '#E77140'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-loader {
    position: relative;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $app-background;
    backdrop-filter: blur(5px);

    .box {
      $s: 20rem;
      width: 1 * $s;
      height: $s;
    }

    .fox {
      height: 100% !important;
      width: 100%;

      :global(& svg [class*=cls-1]) {
        fill: none;
        stroke: currentColor;
        stroke-width: 15px;
        stroke-dasharray: 3;
        stroke-linecap: round;
        animation: stroke 5s linear forwards infinite;
      }

      :global(& svg [class*=eyes]) {
        stroke: black;
      }

      :global(& svg [class*=tail]) {
        stroke: black;
      }
    }

    @keyframes stroke {
      0% {
        stroke-dasharray: 0, 10000;
      }

      40% {
        stroke-dashoffset: 0;
        stroke-dasharray: 5800, 10000;
        fill: transparent;
      }

      50% {
        stroke-dashoffset: 0;
        stroke-dasharray: 5800, 10000;
        fill: currentColor;
      }

      60% {
        stroke-dashoffset: 0;
        stroke-dasharray: 5800, 10000;
        fill: currentColor;
      }

      70% {
        stroke-dashoffset: 0;
        stroke-dasharray: 5800, 10000;
        fill: transparent;
      }

      100% {
        stroke-dashoffset: -5800px;
        stroke-dasharray: 5800, 10000;
      }
    }
  }
</style>
